<!-- ===== Logo animé : déclenchement à l'entrée dans le viewport ===== -->
<div class="pi-logo" aria-label="Logo Legend animé">
  <!-- Cercle -->
  <img class="pi-ring"   src="img/logo/circle.png" alt="Cercle du logo" />
  <!-- Lettre L -->
  <img class="letter" src="img/logo/L.png" alt="Lettre L" />

  <!-- Étoiles (modifie tailles/positions si besoin) -->
  <img class="star s1" src="img/logo/e-5.png" alt="" />
  <img class="star s2" src="img/logo/e-2.png" alt="" />
  <img class="star s3" src="img/logo/e-1.png" alt="" />
  <img class="star s4" src="img/logo/e-3.png" alt="" />
  <img class="star s5" src="img/logo/e-4.png" alt="" />
</div>
<lgb-brand></lgb-brand>